import { forwardRef } from 'react';
import type { InputProps } from '../../../../../types/Form';
import FileInput from '../../../Form/FileInput';

export interface FileInputProps extends Omit<InputProps, 'type'> {
  removeFile: (index: number) => void;
  files: File[];
}
export const FileInputFieldBase = forwardRef<HTMLInputElement, FileInputProps>((props, ref) => {
  const { files, removeFile, ...rest } = props;
  const totalFiles = ((files as File[]) || []).length;

  return (
    <>
      <FileInput
        {...rest}
        ref={ref}
        key={`${files?.length}`}
        value={
          totalFiles > 1 ? `${totalFiles} file${totalFiles > 1 ? 's' : ''} selected` : totalFiles === 1 ? files[0].name : rest.placeholder
        }
        type='file'
      />
      {files?.length > 0 && (
        <div className='my-4'>
          {((files as File[]) || []).map((file, index) => (
            <div className='flex justify-between mt-2' key={index}>
              <span className='truncate'>{file.name} </span>
              <button
                onClick={() => {
                  removeFile(index);
                }}
              >
                &#10005;
              </button>
            </div>
          ))}
        </div>
      )}
    </>
  );
});
